import { styled } from 'opensolar-ui'
import { makeOpenSolarStyles } from 'themes/makeOpenSolarStyles'

export const useRoleFormStyles = makeOpenSolarStyles(
  {
    fieldCont: {
      display: 'flex',
      width: '100%',
      flexWrap: 'wrap',
      gap: 10,
    },
    input: { minWidth: 256, flexGrow: 1, flexShrink: 1 },
  },
  { name: 'RoleForm' }
)

export const InputContainer = styled('div')({
  display: 'flex',
  minWidth: 288,
  flexGrow: 1,
  flexShrink: 1,
  flexBasis: 288,
})
